// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { validateOTP, logout, requestOTP, resetOTPRequest } from '../../actions/auth';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { withStyles } from '@material-ui/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
// import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from '@material-ui/core/Checkbox';
import { FirebaseContext } from '../../context/firebase';
import * as Sentry from '@sentry/browser';
import md5 from 'blueimp-md5';
import config from '../../config';
import { setCookie, deleteCookie } from '../../utils';
import { SIGNUP_PAGE, SIGNUP_DIALOG } from '../../constants';

const styles = {
	loginContainer: {
		padding: '20px',
		// display: 'flex',
		// alignItems: 'center',
		// height: '50vh',
		color: 'white',
		'& > section': {
			display: 'flex',
			flexDirection: 'column',
			textAlign: 'left',
		},
	},
	button: {
		width: '180px',
		lineHeight: '42px',
		backgroundColor: '#bfd730',
		alignSelf: 'center',
		margin: '20px',
		fontSize: '14px',
		fontWeight: 600,
		'&:hover': {
			backgroundColor: '#bfd730',
		},
	},
	// textFieldError: {
	// 	'& .MuiInput-underline': {
	// 		'&:before': {
	// 			borderBottom: '2px solid #f44336'
	// 		}
	// 	},
	// 	'& label': {
	// 		color: '#f44336'
	// 	}
	// },
	progress: {
		color: '#bfd730',
		alignSelf: 'center',
	},
	otpInput: {
		height: '40px',
		letterSpacing: '10px',
	},
	backBtn: {
		// width: "14px",
		padding: '0',
		// height: "30px"
		margin: '0 30px 0 -6px',
	},
	backIcon: {
		fontSize: '28px',
		color: 'white',
		lineHeight: '29px',
	},
	resendOTPBtn: {
		color: '#bfd730',
	},
	logoImg: {
		alignSelf: 'center',
		marginBottom: '30px',
	},
};

const InputTextField = withStyles({
	root: {
		'& .MuiInput-underline, & .MuiTypography-root': {
			color: 'white',
			fontSize: '16px',
			'&:before': {
				borderBottom: '1px solid white',
			},
			'&:after': {
				borderBottom: '1px solid #bfd730',
			},
			'&:hover:not(.Mui-disabled):before': {
				borderBottom: '1px solid white',
			},
		},
		'& label, & .Mui-focused': {
			color: 'white',
			fontWeight: 500,
		},
	},
})(TextField);

const TermsCheckBox = withStyles({
	root: {
		padding: '9px 0',
		color: '#fff',
		alignSelf: 'flex-start',
	},
	checked: {
		color: '#bfd730',
	},
})(Checkbox);

type Props = {
	auth: { [key: string]: any },
	user: { [key: string]: any },
	pod: { [key: string]: any },
	history: { [key: string]: any },
	classes: { [key: string]: any },
	container: string,
	validateOTP: typeof validateOTP,
	requestOTP: (string, string) => void,
	resetOTPRequest: () => void,
};

class Signup extends Component<Props, { [key: string]: any }> {
	static contextType: React$Context<any>;
	state = {
		phone: '',
		termsChecked: false,
		otp: '',
		errorMsg: '',
		showError: false,
	};
	errorState = false;
	componentType: 'SIGNUP' | 'FORGOT_MPIN';
	errorType = React.createRef();

	static getDerivedStateFromProps(props, state) {
		const { user: { mobile } = {} } = props;
		const { phone = '' } = state;
		if (!phone && mobile) {
			return {
				...state,
				phone: mobile,
			};
		}

		return null;
	}

	componentDidMount() {
		const { history = {}, pod: { selectedPod } = {}, container = SIGNUP_PAGE } = this.props;
		const { location: { pathname = '' } = {} } = history;
		if (pathname === '/forgot-mpin') {
			this.componentType = 'FORGOT_MPIN';
		} else {
			this.componentType = 'SIGNUP';
			this.setState({
				termsChecked: true,
			});
		}

		if (this.checkIfSessionIdExists()) {
			if (container === SIGNUP_PAGE) {
				selectedPod ? history.replace('/products') : history.replace('/podlist');
			}
		} else {
			const firebase = this.context;
			if (firebase) {
				firebase.analytics().logEvent(container === SIGNUP_DIALOG ? 'view_login_dialog' : 'view_login_page');
			}

			Sentry.configureScope((scope) => {
				scope.setUser({ id: null });
			});
		}
	}

	componentDidUpdate(prevProps) {
		const {
			auth: { sessionId = null, sessionChecked = false, otpSendStatus = false },
			pod: { selectedPod, affiliateActive, affiliateData } = {},
			user: { mobile } = {},
			history,
			container = SIGNUP_PAGE,
		} = this.props;
		const {
			auth: { otpSendStatus: prevOtpSendStatus = false },
		} = prevProps;
		const firebase = this.context;
		const { phone } = this.state;

		if (otpSendStatus && !prevOtpSendStatus && phone) {
			setCookie('otpSendStatus', String(+otpSendStatus));
			setCookie('user', JSON.stringify({ mobile: phone }));
		}

		if (sessionId && sessionChecked) {
			if (container === SIGNUP_PAGE) {
				const { location: { state: { from } = {} } = {} } = history;
				if (from && from.pathname) {
					history.replace(from.pathname);
				} else {
					if (affiliateActive && affiliateData) {
						const { url } = affiliateData;
						if (url) {
							return history.push(url, { navigated: true });
						}
					}
					selectedPod ? history.replace('/products') : history.replace('/browse');
				}
			}

			if (firebase) {
				firebase.analytics().logEvent('logged_in_using_otp');
				firebase.analytics().setUserId(md5(mobile));
				firebase.analytics().setUserProperties({ version: config.RELEASE_VER });
				if (affiliateActive && affiliateData) {
					const { page_id = 'affiliate' } = affiliateData;
					firebase.analytics().setUserProperties({ location: page_id });
				} else if (selectedPod) {
					firebase.analytics().setUserProperties({ location: selectedPod.location });
				}
			}

			Sentry.configureScope((scope) => {
				scope.setUser({ id: this.state.phone });
			});
		}
	}

	checkIfSessionIdExists() {
		let {
			auth: { sessionId = null },
			user: { mobile } = {},
		} = this.props;
		if (sessionId && mobile) {
			return true;
		}
		return false;
	}

	onMobileSubmit = () => {
		if (
			!this.checkValidity('phone', this.state.phone) ||
			(this.componentType === 'SIGNUP' && !this.checkValidity('termsChecked', this.state.termsChecked))
		) {
			this.errorState = true;
			this.setState({ showError: true });
			return;
		}

		this.props.requestOTP(this.state.phone, this.componentType);
		const firebase = this.context;
		if (firebase) {
			firebase.analytics().logEvent('login_with_mobile');
		}
	};

	// set the state value while user changes the input
	onValueChange = (field, e) => {
		const fieldValue = e.target.value;
		if (field !== 'termsChecked' && e.target.value && e.target.value.search(/\D/) >= 0) {
			return;
		}

		this.checkValidity(field, fieldValue);
		this.setState({
			[field]: field === 'termsChecked' ? !this.state['termsChecked'] : fieldValue,
		});
	};

	checkValidity(field, fieldValue) {
		if (!fieldValue || (typeof fieldValue === 'string' && !fieldValue.trim().length)) {
			this.errorType.current = field;
			this.setState({
				showError: this.errorState,
				errorMsg:
					field === 'phone'
						? 'Enter your phone number'
						: field === 'termsChecked'
						? 'Please accept the terms and conditions '
						: 'Enter your OTP',
			});
			return false;
		} else {
			if (field === 'phone') {
				const re = /[0-9]{10}/;
				if (!re.test(fieldValue)) {
					this.setState({
						showError: this.errorState,
						errorMsg: 'Enter a valid phone number',
					});
					return false;
				}
			}

			this.setState({ showError: false, errrorMsg: '' });
			return true;
		}
	}

	//on click of forgot MPIN
	resetMpin = () => {
		// ReactGA.event({
		//     category: 'MPIN Reset',
		//     action: 'MPIN has been reset'
		// });
	};

	handleLogin = () => {
		if (!this.checkValidity('otp', this.state.otp)) {
			this.errorState = true;
			this.setState({ showError: true });
			return;
		}

		const {
			auth: { sessionId = '' },
		} = this.props;
		this.props.validateOTP(this.state.phone, this.state.otp, this.componentType, sessionId);
		const firebase = this.context;
		if (firebase) {
			firebase.analytics().logEvent('verify_otp_for_login');
		}
	};

	resendOtp = () => {
		this.props.requestOTP(this.state.phone, this.componentType);
		const firebase = this.context;
		if (firebase) {
			firebase.analytics().logEvent('resend_otp_for_login');
		}
	};

	render() {
		const { classes, auth = {}, resetOTPRequest, container = SIGNUP_PAGE } = this.props;
		const { otpSendStatus = false, authenticating = false } = auth;
		const { phone, otp, showError, errorMsg } = this.state;

		return (
			<main style={{ display: 'flex', flexDirection: 'column', fontSize: '14px' }}>
				<div className={classes.loginContainer}>
					{!otpSendStatus || !phone ? (
						<section id='mobile' style={{ marginTop: container === SIGNUP_PAGE ? 40 : 0 }}>
							{container === SIGNUP_PAGE && (
								<img src='/logo.png' alt='logo' width='160px' height='160px' className={classes.logoImg} />
							)}
							<InputTextField
								label='Mobile Number'
								id='mobile-number'
								fullWidth
								value={phone}
								InputProps={{
									startAdornment: <InputAdornment position='start'>+91</InputAdornment>,
									inputProps: {
										inputMode: 'numeric',
										maxLength: '10',
										autoFocus: true,
									},
								}}
								onChange={this.onValueChange.bind(this, 'phone')}
							/>
							{this.componentType === 'SIGNUP' && (
								<section>
									<TermsCheckBox
										value={this.state.termsChecked}
										onChange={this.onValueChange.bind(this, 'termsChecked')}
										color='default'
										checked={this.state.termsChecked}
									/>
									<span style={{ marginLeft: '6px' }}>
										I accept the
										<a
											href='/terms-and-conditions'
											target='_blank'
											style={{ textDecoration: 'unset', color: '#bfd730' }}
										>
											Terms and conditions
										</a>
									</span>
								</section>
							)}
							{showError && <div style={{ color: 'white', marginTop: '1px' }}>{errorMsg}</div>}
							<Button variant='contained' className={classes.button} onClick={() => this.onMobileSubmit()}>
								Login
							</Button>
							<div style={{ textAlign: 'center' }}>
								We will send a<b> One Time Password </b> on this mobile number
							</div>
						</section>
					) : (
						<section>
							<section style={{ display: 'flex', marginBottom: container === SIGNUP_PAGE ? 60 : 20 }}>
								<IconButton aria-label='back' classes={{ root: classes.backBtn }} onClick={() => resetOTPRequest()}>
									<Icon className={classes.backIcon}>arrow_back</Icon>
								</IconButton>
								<div
									style={{
										fontSize: '16px',
										alignSelf: 'center',
									}}
								>
									OTP verification
								</div>
							</section>
							<div> Enter the OTP sent to +91 {this.state.phone}</div>
							<InputTextField
								required
								fullWidth
								id='otp'
								type='password'
								classes={{
									root: showError ? classes.textFieldError : '',
								}}
								InputProps={{
									classes: {
										input: classes.otpInput,
									},
									inputProps: {
										maxLength: 4,
										inputMode: 'numeric',
									},
								}}
								value={otp}
								onChange={this.onValueChange.bind(this, 'otp')}
							/>
							{showError && <div style={{ color: 'white', marginTop: '1px' }}>{errorMsg}</div>}
							<Button variant='contained' className={classes.button} onClick={() => this.handleLogin()}>
								Verify
							</Button>
							<div style={{ textAlign: 'center' }}>
								Didn't get the verification code
								<Button className={classes.resendOTPBtn} onClick={this.resendOtp}>
									Resend OTP
								</Button>
							</div>
						</section>
					)}
				</div>
				{authenticating && <CircularProgress className={classes.progress} size={60} thickness={2} />}
			</main>
		);
	}

	componentWillUnmount() {
		deleteCookie('otpSendStatus');
	}
}

Signup.propTypes = {
	auth: PropTypes.object.isRequired,
	user: PropTypes.object.isRequired,
	validateOTP: PropTypes.func.isRequired,
	requestOTP: PropTypes.func.isRequired,
	pod: PropTypes.object.isRequired,
};

Signup.contextType = FirebaseContext;

const mapStateToProps = (state, props) => {
	return {
		auth: state.auth,
		user: state.user,
		pod: state.pod,
		...props,
	};
};

export default withStyles(styles)(
	connect(mapStateToProps, {
		validateOTP,
		logout,
		requestOTP,
		resetOTPRequest,
	})(Signup)
);
